<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card style="min-width: 700px" class="card-authorization">
        <q-card-section class="header" v-show="showIcon">
          <div class="text-h6 text-center" id="title-card-authorization">
            <q-img
            :src="require(`@/assets/img/warning-amber-black-24-dp.svg`)"
            class="icon"
            />
          </div>
        </q-card-section>
        <q-card-section class="container-desauth q-pt-none q-col-gutter-y-sm">
          <div class="title-delete text-center">
            {{ txtContainer }}
          </div>
        </q-card-section>
        <q-card-actions align="center" class="text-primary container-actions">
          <q-btn color="primary" :label="labelCancel" padding="xs lg" v-close-popup @click="cancel()" />
          <q-btn
            :label="labelDelete"
            flat
            padding="xs lg"
            @click="remove()"
            :loading="isLoading"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog, QImg } from 'quasar';
export default {
  components: {
    QDialog,
    QImg
  },
  props: {
    value: {
      required: true
    },
    showIcon: {
      required: false,
      type: Boolean,
      default: () => false
    },
    txtContainer: {
      required: true,
      type: String,
      default: () => 'Default Txt'
    },
    dataCy: {
      required: false,
      type: String,
      default: () => ''
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: () => false
    },
    labelDelete: {
      required: false,
      type: String,
      default: () => 'Cancelar'
    },
    labelCancel: {
      required: false,
      type: String,
      default: () => 'Permanecer'
    }
  },
  data () {
    return {
      valueLocal: this.value
    };
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    remove () {
      this.$emit('save');
    }
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-desauth {

    .title-delete {
      padding: 11px 20px 30px 20px;
      font-family: 'DINPro-Bold';
      font-size: 22px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #4d4d4d;
    }
  }
  .container-actions {
    padding-bottom: 30px;
  }
  .q-img{
    width: 35px;
  }
</style>
